import React from 'react'

const NetworkErrorPage = () => {
  return (
    <div>Please check your internet </div>
  )
}

export default NetworkErrorPage